import { render, staticRenderFns } from "./DarvasBoxes.vue?vue&type=template&id=9bbb4f68&scoped=true"
import script from "./DarvasBoxes.vue?vue&type=script&lang=js"
export * from "./DarvasBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbb4f68",
  null
  
)

export default component.exports